import Vue from 'vue'
import Vuex from 'vuex'
import NProgress from "nprogress";
import "@/assets/scss/nprogress.custom.scss";
import members from './members.module';
import posts from './posts.module';
import search from './search.module';
import settings from './settings/settings.module';

Vue.use(Vuex)

NProgress.configure({ parent: '.si-navbar', showSpinner: true })

export default new Vuex.Store({
  state: {
    postButton: false
  },
  getters: {
    postButton(state) {
      return state.postButton;
    }
  },
  mutations: {
    SET_POST_BUTTON(state, payload) {
      state.postButton = payload;
    }
  },
  actions: {
    showBusy() {
      NProgress.start();
    },
    hideBusy() {
      NProgress.done();
    },
    showPostButton({ commit }) {
      commit("SET_POST_BUTTON", true);
    },
    hidePostButton({ commit }) {
      commit("SET_POST_BUTTON", false);
    },
  },
  modules: {
    members,
    posts,
    search,
    settings
  }
})
